<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-height="680"
    scrollable
    :fullscreen="$vuetify.display.xs"
    :width="$vuetify.display.smAndUp ? 600 : 'auto'"
    style="z-index: 1100 !important;"
    class="vb-dialog vb-dialog-danger"
  >
    <v-card v-cloak>
      <v-card-title class="dialog-title d-flex justify-space-between">
        {{ $t('console.ftpUsersDeleteUser') }}

        <v-btn icon @click="dialog = false;">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text scrollable class="scrollable mt-4">
        <span>
          {{ $t('console.ftpUsersConfirmDelete') }}
        </span>
        <br/>
        <br/>
        <strong>{{ ftpUser?.username }}</strong>
        <p v-if="ftpUser?.user" class="mt-4">
          {{ $t('console.credentialsRelatedToUser') }}: <br/>
          {{ ftpUser.user.name }} ({{ ftpUser.user.email }})
        </p>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          type="submit"
          class="bg-red-darken-3"
          elevation="0"
          :loading="isSubmitting"
          :disabled="isSubmitting"
          @click="deleteUser"
        >
          {{ $t('common.delete') }}
        </v-btn>
        <v-btn variant="text" @click="dialog = false">{{ $t('common.cancel') }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { useAuthStore } from '@/stores/AuthStore.js';
import { useFtpUserStore } from '@/stores/FtpUserStore.js';
import DialogActionKeys from '@/components/mixin/DialogActionKeys.js';
import DialogModel from '@/components/mixin/DialogModel.js';

export default {
  name: 'FTPUserDeleteDialog',
  mixins: [DialogActionKeys, DialogModel],
  props: {
    ftpUser: {
      type: Object,
      default: null
    },
  },
  data() {
    return {
      isSubmitting: false,
    };
  },
  methods: {
    async deleteUser() {
      if (!this.rootNodeId || !this.ftpUser) {
        return;
      }

      try {
        this.isSubmitting = true;

        const ftpUserStore = useFtpUserStore();
        await ftpUserStore.deleteFtpUser(this.rootNodeId, this.ftpUser.id);

        this.$emit('deleted');
        this.dialog = false;
      } catch (error) {
        console.error('Failed to delete FTP user:', error);

        let errorMessage = this.$t('backend.system-error');
        if (error?.response?.data?.error) {
          errorMessage = this.$localizeMessage(error.response.data.error);
        }

        if (this.$showMessage) {
          this.$showMessage(errorMessage, { type: 'error' });
        } else {
          // Fallback if global message helper isn't available in this context
          alert(errorMessage);
        }
      } finally {
        this.isSubmitting = false;
      }
    },
  },
  computed: {
    rootNodeId() {
      const authStore = useAuthStore();
      return authStore.rootNodeId;
    },
  }
}
</script>

<style scoped>
</style>
